export const indicators = {
  Publications:
    "The total number of a researcher's articles, reflecting their productivity.",
  Datasets:
    "The total number of a researcher's datasets, reflecting their productivity.",
  Software:
    "The total number of a researcher's software, reflecting their productivity.",
  Other:
    "The total number of a researcher's other works, reflecting their productivity.",
  Citations:
    "The total number of citations received by all articles of the researcher of interest.",
  "h-index":
    "It is an estimation of the importance, significance, and broad impact of a researcher's cumulative research contributions.",
  "i10-index":
    "This is a simple measure introduced by Google Scholar that helps gauge the productivity of a researcher.",
  Popular: "The number of popular works of the researcher of interest.",
  Influential: "The number of influential works of the researcher of interest.",
  "Aggregated Popularity":
    "The sum of the popularity (current impact) scores of all articles of a researcher of interest.",
  "Aggregated Influence":
    "The sum of the influence (total/overall impact) scores of all articles of a researcher of interest.",
  "Aggregated Impulse":
    "The sum of the impulse scores of all articles of a researcher of interest.",
  OAShare:
    "The share (proportion) of articles of the researchers of interest that are open access.",
  OAWorks:
    "The total count of articles of the researchers of interest that are open access.",
  OAInfluential:
    "The total count of influential articles of the researchers of interest that are open access.",
  OAPopular:
    "The total count of popular articles of the researchers of interest that are open access.",
  Academic_Age:
    "It reflects the time that a scientist has been in the research field and performed active research.",
  Fair_Academic_Age:
    "A variant of the academic age indicator that takes into consideration a researcher's inactive periods.",
};
